import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonCard, IonIcon} from '@ionic/react';
import {checkmarkCircle} from 'ionicons/icons'
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';

import './css/general.css';
import styles from './css/Feedback.module.css';

interface FeedbackProps extends RouteComponentProps {
    // Define the props here
  }
  
  interface FeedbackState {
    // Define the state here
    message: string,
  }
  
  const token = localStorage.getItem("token");
  
  class SubjectFeedback extends React.Component<FeedbackProps, FeedbackState> {
    constructor(props: FeedbackProps) {
      super(props);
  
      this.state = {
        message: "",
      };
    }

  submitFeedback(){
    var employeeId = localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let regExp = /[a-zA-Z]/g;

    //console.log(this.state.message)

    if (regExp.test(this.state.message)) {
      axiosInstance
        .post(
          "/Feedbacks",
          {
            Message: this.state.message,
            UserId: employeeId,
            SubjectID: localStorage.getItem("subjectId")
          },
          config
        )
        .then((error) => {
          console.log(error);
        });

      // toon popup
      this.showPopup()
    } else {
      alert("Pas op! Je kan geen lege berichten versturen.");
    }
      }
    
    showPopup(){
      let popup = document.getElementById("popup");
      if(popup != null){
          popup.style.display = "block";
      }
    
    }
    
    goBack(){
      const {history} = this.props;
      history.go(-1);
    }
    
      render(){
        return(
          <IonPage>
              <IonHeader class="ion-no-border">
                  <IonToolbar>
                  <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                      <IonTitle>Subject Feedback</IonTitle>
                  </IonToolbar>
              </IonHeader>
              <IonContent fullscreen>
                  <div className="whiteBG">
                      <div className={(styles.feedback)}>
                          <h1>Feedback</h1>
                          <p className={(styles.feedbackText)}>Heb je suggesties voor deze case? <br/> Laat het ons zeker weten!</p>
                          <input 
                          name="feedback" 
                          className={(styles.inputFeedback)} 
                          placeholder="Schrijf hier je boodschap"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>)=> this.setState({message: e.target.value})}
                          />                      </div>
                      <IonButton shape="round" size= "large" onClick={() => this.submitFeedback()}>Verzenden</IonButton>


                      {/* popup */}
                    <IonCard className={(styles.popupSubmitted)} id="popup">
                    <IonIcon icon={checkmarkCircle} className={(styles.checkIcon)}></IonIcon>
                      <p>Bedankt!</p>
                      <p>Je feedback is met succes verzonden.</p>
                      <button className={(styles.btn)} onClick={() => this.goBack()}>Begrepen</button>
                    </IonCard>
                  </div>
              </IonContent>
          </IonPage>
      );
    }
    };

export default withRouter(SubjectFeedback);
